(function($){
  $(function(){
    $('.events__load-more').on('click', function(){
      var offset = $(this).data('offset');

      $.ajax({
        url: window.ajaxurl,
        type: "POST",
        data: {
          'action': 'get_events',
          'offset': offset,
        }
      }).done(function(response){
        var offset = parseInt($('.events__load-more').data('offset'));
        offset += $(response).filter('.link-row').length;
        if (offset >= $('.events__load-more').data('max')){
          $('.events__load-more').hide();
        }
        $('.events__load-more').data('offset', offset);
        $('.events > .l-padding-lr > .l-wrapper').append(response);
        window.App.EventsAgenda();
      });
    });
  });
})(jQuery);
